var _ellipse, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithubLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15,
    cy: 15,
    rx: 15,
    ry: 15,
    fill: "#2F80ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 15.6179C28 23.7001 23.1279 30 15 30C6.87207 30 2 23.7001 2 15.6179C2 7.53564 6.62673 0.983643 14.7547 0.983643C22.8826 0.983643 28 7.53564 28 15.6179Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0123 0C6.71091 0 0 6.76227 0 15.1281C0 21.8154 4.29991 27.476 10.265 29.4795C11.0108 29.6301 11.284 29.154 11.284 28.7535C11.284 28.4027 11.2594 27.2006 11.2594 25.948C7.08334 26.8499 6.21371 24.1447 6.21371 24.1447C5.54259 22.3914 4.5482 21.9408 4.5482 21.9408C3.18137 21.0141 4.64776 21.0141 4.64776 21.0141C6.16393 21.1143 6.95951 22.5669 6.95951 22.5669C8.30144 24.871 10.4638 24.22 11.3338 23.8192C11.4579 22.8423 11.8559 22.1661 12.2784 21.7905C8.94767 21.4398 5.44334 20.1374 5.44334 14.3265C5.44334 12.6734 6.03948 11.321 6.98409 10.2691C6.83505 9.8935 6.31297 8.34033 7.13343 6.26155C7.13343 6.26155 8.401 5.86073 11.2591 7.81441C12.4828 7.48327 13.7447 7.31481 15.0123 7.31339C16.2799 7.31339 17.5721 7.4889 18.7653 7.81441C21.6237 5.86073 22.8913 6.26155 22.8913 6.26155C23.7117 8.34033 23.1893 9.8935 23.0403 10.2691C24.0098 11.321 24.5814 12.6734 24.5814 14.3265C24.5814 20.1374 21.077 21.4146 17.7214 21.7905C18.2684 22.2663 18.7404 23.1678 18.7404 24.5956C18.7404 26.6243 18.7158 28.2524 18.7158 28.7532C18.7158 29.154 18.9893 29.6301 19.7348 29.4798C25.6999 27.4757 29.9998 21.8154 29.9998 15.1281C30.0244 6.76227 23.2889 0 15.0123 0Z",
    fill: "#2F80ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubLogo);
export default __webpack_public_path__ + "static/media/githubLogo.f83b925364c07160e56d5be92a07ee9f.svg";
export { ForwardRef as ReactComponent };